import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import {
  EIntegrationStatus,
  TCustomField,
} from 'src/app/project/modules/custom-fields/custom-fields.model';

const COST_DECIMAL_PLACES = 2;
const PERCENTAGE_DECIMAL_PLACES = 0;
const PERCENTAGE_UNIT = '%';
const DEFAULT_NUMBERS_DECIMAL_PLACES = 0;
const MIN_NUMBERS_DECIMAL_PLACES = 0;
const MAX_NUMBERS_DECIMAL_PLACES = 4;
const VOLY_INTEGRATION_ACTIVE = [EIntegrationStatus.ON, EIntegrationStatus.DISABLED];

const isVolyIntegrationField = (field: TCustomField): boolean =>
  field.type === ECustomFieldType.COST &&
  VOLY_INTEGRATION_ACTIVE.includes(field.volyIntegrationActive);

export const isNumericFieldLocked = (field: TCustomField): boolean =>
  field.lockedValue && !isVolyIntegrationField(field);

export type TNumericFormat = {
  unit: string | undefined;
  decimalPlaces: number;
  useGrouping: boolean;
};

const getNumbersDecimalPlaces = (rawDecimalPlaces: string | number | undefined): number => {
  const parsed = Number(rawDecimalPlaces);
  if (Number.isNaN(parsed)) {
    return DEFAULT_NUMBERS_DECIMAL_PLACES;
  }
  return Math.min(Math.max(parsed, MIN_NUMBERS_DECIMAL_PLACES), MAX_NUMBERS_DECIMAL_PLACES);
};

export const getNumericFormat = (
  field: TCustomField,
  type: ECustomFieldType | undefined = field.type,
): TNumericFormat => {
  if (type === ECustomFieldType.COST) {
    return { unit: field.currencyCode, decimalPlaces: COST_DECIMAL_PLACES, useGrouping: true };
  }
  if (type === ECustomFieldType.PERCENTAGE) {
    return { unit: PERCENTAGE_UNIT, decimalPlaces: PERCENTAGE_DECIMAL_PLACES, useGrouping: true };
  }
  return {
    unit: field.unit || undefined,
    decimalPlaces: getNumbersDecimalPlaces(field.decimalPlaces),
    useGrouping: Boolean(field.showCommas),
  };
};
